export default {
  blanklayout: () => import("/var/www/html/layouts/blanklayout.vue"),
  custom: () => import("/var/www/html/layouts/custom.vue"),
  default: () => import("/var/www/html/layouts/default.vue")
}